import React from "react";

export function useSubdomainName() {
    const [domainName, setDomainName] = React.useState<string | undefined>();

    React.useEffect(() => {
        if (typeof window !== "undefined") {
            setDomainName(window.location.hostname.split(".")[0]);
        }
    }, []);

    return {
        subDomain: domainName,
    };
}
